import { Page } from 'layouts/Page';
import { CommunicationHistoryDetail } from 'components/EMManagement/EMManagementId/CommunicationHistory/CommunicationHistoryDetail';

export const CommunicationHistoryDetailPage = () => {
	return (
		<Page title="Communication History – Email details – EAS Control Center">
			<CommunicationHistoryDetail />
		</Page>
	);
};
